export const environment = {
  instance: "qa",
  production: false, 
  showLogs: true,
  region: 'ap-southeast-1', 
  bucketName: 'bbb-qa-storage',
  cognitoUserPoolId: 'ap-southeast-1_yrq9qRpnd', 
  cognitoAppClientId: '1ko9ha75hinnjkckp10bgbur44', 
  cognitoIdentityEndpoint: 'cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_yrq9qRpnd', 
  cognitoIdentityPoolId: 'ap-southeast-1:6ff562b9-3023-494d-a03f-052e58978f10',
  apiEndpoint: 'https://ribwcyvaej.execute-api.ap-southeast-1.amazonaws.com/qa/',  
  publicEndpoint: 'https://bocpwcsdevserver.eschost2.com/',
  googleMapApiKey: "AIzaSyAXAAS1IVULg5pjMzSSdN8B2KfKtxTlNnI",
  showFaqFirst: true,
  allowLogin: true,
  allowSignup: true,
  consolidatorFaqUrl: "https://imsbbbconsolqa.eschost2.com/frequently-asked-questions",
  deconsolidatorFaqUrl: "https://imsbbbdeconsolqa.eschost2.com/frequently-asked-questions",
  ofwFaqUrl: "https://imsbbbqa.eschost2.com/frequently-asked-questions",
  auth: {
    identityPoolId: 'ap-southeast-1:6ff562b9-3023-494d-a03f-052e58978f10',
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_yrq9qRpnd',
    userPoolWebClientId: '1ko9ha75hinnjkckp10bgbur44',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_SRP_AUTH'
  },
  api: {
    endpoints: [
      {
        name: "OFWPortalAPI",
        endpoint: "https://ribwcyvaej.execute-api.ap-southeast-1.amazonaws.com"
      }
    ]
  }
};